import { takeEvery } from 'redux-saga'
import { put, call, fork } from 'redux-saga/effects'
import * as PaymentAPI from 'api/payment.api.js'

export function* FetchProductInfo(action) {
  const productInfo = yield call(PaymentAPI.FetchProductInfo, action);
  yield put({type: 'SET_PRODUCT_INFO', productInfo });
}

export function* FetchProductInfoFlow() {
  yield takeEvery('FETCH_PRODUCT_INFO', FetchProductInfo);
}

export function* FetchOnboardingOptions(action) {
  const onboardingGoalOptions = yield call(PaymentAPI.FetchOnboardingOptions, action);
  yield put({type: 'SET_ONBOARDING_OPTIONS', onboardingGoalOptions });
}

export function* FetchOnboardingOptionsFlow() {
  yield takeEvery('FETCH_ONBOARDING_OPTIONS', FetchOnboardingOptions);
}

export function* StripePassCredentials(action) {
  yield PaymentAPI.StripePassCredentials(action.authCode, action.scope);
}

export function* StripePassCredentialsFlow() {
  yield takeEvery('STRIPE_PASS_CREDENTIALS', StripePassCredentials);
}

export function* InitUpdateCard(action) {
  yield call(PaymentAPI.InitUpdateCard, action);
}

export function* InitUpdateCardFlow() {
  yield takeEvery('INIT_UPDATE_CARD', InitUpdateCard);
}

export default function* Payment(getStore) {
  yield [
    fork(FetchProductInfoFlow),
    fork(FetchOnboardingOptionsFlow),
    fork(StripePassCredentialsFlow),
    fork(InitUpdateCardFlow),
  ];
}


// WEBPACK FOOTER //
// ./src/sagas/PaymentSaga.js